export enum FileUploadStatusEnum {
  /**Загружается */
  Uploading = "uploading",
  /**В обработке */
  Processing = "processing",
  /**На паузе */
  Pause = "pause",
  /**На отмену */
  Abort = "abort",
  /**Загружен */
  Uploaded = "uploaded",
}
